module.exports = __webpack_public_path__ + "media/Paint_OUT.b651047e.mp4";